import EscrevaContainer from './escreva.container'

export default EscrevaContainer
